module.exports = __webpack_public_path__ + "img/commands_persue.0ac38f66.svg";